//matrial ui
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
//hooks
import useLocales from "src/hooks/useLocales";

export default function MealVideoPopUp(props) {
  const { open, close, data } = props;
  const { translate, currentLang } = useLocales();

  return (
    <Dialog open={open} onClose={close} fullWidth>
      <DialogTitle>
        {currentLang.value === "ar" ? data?.meal_arabic_name : data?.meal_name}
      </DialogTitle>
      <DialogContent sx={{ px: 0 }}>
        <Box pt={3}>
          <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
            <iframe
              width="560"
              height="315"
              src={data?.meal_video}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
            ></iframe>
          </div>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="error" variant="outlined">
          {translate(
            "componentsTranslations.mealVideoPopUpTranslations.cancel"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
